module.exports = __webpack_public_path__ + "static/media/increase.84724fb3.svg";